import { NavLink } from "react-router-dom";
import clsx from "clsx";

const Sidebar = ({
  title = "Menu",
  items = [],
  footer = null,
  className = "",
}) => {
  const navLinkClass = ({ isActive }) =>
    clsx(
      "block rounded-xl px-4 py-3 text-sm font-medium transition",
      isActive
        ? "bg-[#8B3A3A] text-white shadow-sm"
        : "text-[#3b2f2f] hover:bg-[#f7f1e8] hover:text-[#8B3A3A]"
    );

  return (
    <aside
      className={clsx(
        "rounded-2xl border border-[#ead8c0] bg-white p-4 shadow-sm",
        className
      )}
    >
      <div className="mb-4 px-2">
        <h2 className="text-lg font-semibold text-[#8B3A3A]">{title}</h2>
      </div>

      <nav className="space-y-2">
        {items.map((item) => {
          const Icon = item.icon;

          return (
            <NavLink key={item.to} to={item.to} end={item.end} className={navLinkClass}>
              <span className="flex items-center gap-3">
                {Icon ? <Icon size={18} /> : null}
                <span>{item.label}</span>
              </span>
            </NavLink>
          );
        })}
      </nav>

      {footer ? <div className="mt-4 border-t border-[#f1e4d3] pt-4">{footer}</div> : null}
    </aside>
  );
};

export default Sidebar;